import React, { useState } from "react";
import { AddNewButtonDialog } from "./AddNewButtonDialog";
import { AddNewButtonLocationDialog } from "./AddNewButtonLocationDialog";

export const AddNewButtonLocationFlow = ({
  handleClose,
  refreshList,
  setCurrentButtonId,
  selectedPractice = null,
}) => {
  const [buttonId, setButtonId] = useState("");
  const [buttonType, setButtonType] = useState("");

  return (
    <>
      <AddNewButtonDialog
        open={!buttonId}
        handleClose={() => handleClose(false)}
        setButtonId={setButtonId}
        setButtonType={setButtonType}
      />
      <AddNewButtonLocationDialog
        buttonId={buttonId}
        buttonType={buttonType}
        handleClose={() => handleClose(false)}
        refreshList={refreshList}
        setCurrentButtonId={setCurrentButtonId}
        selectedPractice={selectedPractice}
      />
    </>
  );
};
